import styled from "styled-components";
export const AIMessageStyled = styled.div`
  border: ${({ noBorderShadow, active }) => noBorderShadow ? 'none' : `1px solid ${active ? "#000000CC" : "#e6e6e6"}`};
  box-shadow: ${({ noBorderShadow }) => noBorderShadow ? 'none' : '0px 4px 10px 0px #0000000f'};
  padding: 1.2rem;
  max-width: ${({ noBorderShadow }) => noBorderShadow ? 'none' : '55rem'};
  width: ${({ noBorderShadow }) => noBorderShadow ? '100%' : 'fit-content'};
  border-radius: 0.6rem;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
